import { SigningStatusBadge } from "@/modules/signing/entities/signing-status/signing-status-badge/signing-status-badge";
import Card from "@/shared/data-display/card";
import Text from "@/shared/typography/text";
import { List } from "@/shared/data-display/list";
import { SignRegistrationForDocumentToSignFragment } from "gql/graphql";
import { usePalette } from "@/shared/theme";
import { useTranslations } from "use-intl";
import Button from "@/shared/form/button";
import { DownloadOutlined } from "@ant-design/icons";

export type DocumentToSignViewProps = {
  signRegistration: SignRegistrationForDocumentToSignFragment;
  activeId?: string;
  setActiveId?: (activeId: string) => void;
};

export function DocumentToSignView({
  signRegistration,
  setActiveId,
  activeId,
}: DocumentToSignViewProps) {
  const palette = usePalette();
  const t = useTranslations("Signing");
  const tc = useTranslations("Common");

  return (
    <Card
      size={"small"}
      title={t("Documents to Sign")}
      extra={
        <Text as={"span"} type="caption" color="secondary">
          {tc("{number} documents", {
            number: signRegistration.documents.length,
          })}
        </Text>
      }
    >
      <List
        split={false}
        dataSource={signRegistration.documents}
        renderItem={(document) => (
          <List.Item key={document.id}>
            <div className={"w-full flex items-center gap-2"}>
              <Card
                size={"small"}
                onClick={() => setActiveId?.(document.id)}
                className={"w-full cursor-pointer"}
                style={{
                  borderColor:
                    activeId === document.id ? palette.primary[5] : undefined,
                  backgroundColor:
                    activeId === document.id ? palette.primary[0] : undefined,
                }}
              >
                <div className="flex items-center justify-between w-full gap-2">
                  <Text
                    as={"span"}
                    type="body2"
                    weight="500"
                    className={"ellipsis"}
                  >
                    {document.fileTitle}
                  </Text>

                  <SigningStatusBadge status={document.status} />
                </div>
              </Card>

              <Button
                icon={<DownloadOutlined />}
                href={document.file.downloadLink}
              />
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
}
